import { Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { colors } from "../../../../ui/colors";

interface Props {
  alias: string;
  email: string;
  removeWorkforce?: () => void;
}

export default function CardInfoWorkforce({ alias, email, removeWorkforce }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        bgcolor: colors.orange[100],
        borderRadius: 16,
        py: 0.5,
        px: 1.5,
        ml: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          color: "var(--fx-surface-text, #0F172A)",
          fontWeight: 800,
          whiteSpace: "normal",
          wordBreak: "break-all",
        }}
      >
        {alias}
      </Typography>
      {" · "}
      <Typography
        sx={{
          fontSize: 10,
          lineHeight: 1,
          color: colors.orange.base,
          fontWeight: 700,
          whiteSpace: "normal",
          wordBreak: "break-all",
        }}
      >
        {email}
      </Typography>

      {removeWorkforce && (
        <IconButton
          size="small"
          onClick={removeWorkforce}
          sx={{
            p: 0.25,
            color: colors.orange.base,
            "&:hover": {
              bgcolor: colors.orange[200],
            },
          }}
        >
          <Close sx={{ fontSize: 14 }} />
        </IconButton>
      )}
    </Box>
  );
}